import { RouterProvider } from "react-router-dom";
import { mobileRouter } from "./mobile";
import { useAppSelector } from "../hooks/redux";
import { publicRouter } from "./public";
import { useRouterHook } from "../hooks/useRouterHook";
import {
  amplifyProvider,
  authController,
  circadiaEngineProvider,
  clinicController,
  localStorageProvider,
  notificationController,
  patientController,
  timeProvider,
  summaryController,
  homeHealthController,
  pushNotificationProvider,
  smsController,
} from "../AppController";
import { appNotification } from "../util/appNotification";
import useSWRImmutable from "swr/immutable";
import { restrictedRouter } from "./restricted";
import { isPIN } from "../util/pin";
import VitalsRedirectHandler from "../components/VitalsRedirectHandler";
import { useVitalsSubdomainRedirect } from "../hooks/useVitalsSubdomainRedirect";

export const AppRouter = () => {
  // Handle vitals subdomain redirect - backup check
  useVitalsSubdomainRedirect();

  const { getAuthState, populateAppData } = useRouterHook({
    amplifyProvider: amplifyProvider,
    authController: authController,
    clinicController: clinicController,
    localStorageProvider: localStorageProvider,
    notificationController: notificationController,
    timeProvider: timeProvider,
    appNotification: appNotification,
    patientController: patientController,
    circadiaEngineProvider,
    summaryController,
    homeHealthController,
    isPIN,
    smsController: smsController,
  });
  const isBiometric = localStorageProvider.get("isBiometric");
  const getAuthStateP = async () => {
    if (isPIN()) {
      // Mobile flow (PIN/biometric)
      const authState = await getAuthState();

      if (isBiometric && isBiometric === "true" && authState === "biometric") {
        await populateAppData();
      }
    } else {
      // Web flow (no PIN/biometric)
      await getAuthState();
      await populateAppData();
      await pushNotificationProvider.registerDeviceForPushNotifications();
    }
  };
  useSWRImmutable("getAuthState", getAuthStateP);

  const { isAuthorized, isPinAuthorized, hasNoAccess } = useAppSelector(
    (state) => {
      return {
        isAuthorized: state.auth.isAuthorized,
        isPinAuthorized: state.auth.isPinAuthorized,
        hasNoAccess: state.auth.hasNoAccess,
      };
    }
  );
  if (!isAuthorized || (isPIN() ? !isPinAuthorized : false)) {
    return <RouterProvider router={publicRouter} />;
  }

  if (hasNoAccess) {
    return <RouterProvider router={restrictedRouter} />;
  }

  // circadiaEngineProvider.changeAppTopAndBottom("#f5f5f5", "#fff");
  return (
    <>
      <VitalsRedirectHandler />
      <RouterProvider router={mobileRouter} />
    </>
  );
};
